import { createContext, useContext } from "preact/compat";
import type { GraphQLClient } from "graphql-request";
import type { ComponentChildren } from "preact";

const Context = createContext<undefined | GraphQLClient>(undefined);

type ApiClientProviderProps = {
	readonly client: GraphQLClient;
	readonly children: ComponentChildren;
};

function ApiClientProvider({ client, children }: ApiClientProviderProps) {
	return <Context.Provider value={client}>{children}</Context.Provider>;
}

function useApiClient(): GraphQLClient {
	const client = useContext(Context);
	if (client === undefined) {
		throw new Error("No API client context");
	}
	return client;
}

export { ApiClientProvider, useApiClient };
